import { MessageCircle } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { waLink } from "@/lib/api";

export const WhatsAppFloat = () => {
  const { settings } = useApp();
  return (
    <a href={waLink(settings.whatsapp, "Hola, quisiera consultar sobre la genética de Hacienda Fernández & Vargas.")}
      target="_blank" rel="noreferrer" data-testid="floating-whatsapp-button" aria-label="Consultar por WhatsApp"
      className="group fixed bottom-4 right-4 sm:bottom-5 sm:right-5 z-50 flex items-center gap-3">
      <span className="hidden sm:block rounded-full bg-white px-4 py-2 text-sm font-semibold text-[#1D3324] shadow-lg opacity-0 translate-x-2 transition-[opacity,transform] duration-300 group-hover:opacity-100 group-hover:translate-x-0">
        ¿Consultas sobre genética?
      </span>
      <span className="wa-pulse flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl transition-transform duration-300 group-hover:scale-110">
        <MessageCircle size={26} />
      </span>
    </a>
  );
};
